import uF from './useFlash'
import Provider from './Context'

export const useFlash = uF

export default Provider
